import './comment.directive.ajscss';

import templateUrl from './comment.directive.html';

const MAX_POPUP_HEIGHT = 170;

/**
 * @deprecated, prefer {@link CommentTooltipComponent}
 */
export const CommentDirective = () => ({
  restrict: 'E',
  transclude: true,
  scope: {
    icone: '@?',
    date: '=?',
    modifications: '<?',
    text: '<',
    textfirstchar: '<?',
    transcludeActivated: '@?',
    readOnly: '@?',
    customTitle: '<?',
    containerSelector: '@?',
    alignBottomWithParent: '@?',
  },
  link: CommentDirectiveLinkFunction,
  templateUrl,
});

export const CommentDirectiveLinkFunction = (scope, elem, attrs) => {
  scope.$watch('text', newValue => {
    scope.text = newValue;
    scope.hasComment = scope.text && scope.text !== '';
  });

  scope.$watch('text1', newValue => {
    scope.text1 = newValue;
  });

  scope.$watch('text2', newValue => {
    scope.text2 = newValue;
  });

  scope.date = scope.date || '';
  scope.text = scope.text || '';
  scope.position = scope.position || '';
  scope.transcludeActivated = scope.$eval(scope.transcludeActivated) || false;
  scope.readOnly = scope.$eval(attrs.readOnly) || false;
  scope.visible = false;
  scope.icone = scope.icone || 'cng-ico_note';
  scope.customTitle = scope.customTitle || '';
  scope.hasComment = scope.text && scope.text !== '';

  scope.text1 = scope.text1 || '';
  scope.text2 = scope.text2 || '';

  let $item = $(elem);
  let $popup = $('.comment_wrapper .comment_popup', $item);

  scope.hover = visible => {
    if (scope.readOnly) return;
    if (visible) {
      if (scope.position.search('fixed') >= 0) {
        $popup = $('.comment_wrapper .comment_popup', $item);
        // grab the item's position relative to its positioned parent
        let $itemIcon = $('.comment_wrapper .comment_icon', $item);

        // place the popup in the correct position relevant to the menu item
        const iconOffSet = $itemIcon.offset();
        const iconPosition = !!iconOffSet ? iconOffSet : { top: 0, left: 0 };
        let left = iconPosition.left + $itemIcon.outerWidth();

        $popup.css({
          top: iconPosition.top,
          left: left,
          position: 'fixed',
        });

        if (scope.position.search('left') >= 0) {
          // calc position in left postion of tooltip icone, 22.5 is max-width 20 + 2.5 is arrow with margin
          $popup.css('left', 'calc(' + left + 'px - 22.5em)');
        }
      }

      if (scope.containerSelector) {
        const $container: any = $item.closest(scope.containerSelector);
        const containerOffset = $container.offset();
        const itemOffset = $item.offset();
        if (containerOffset && itemOffset) {
          const bottomOverflow = itemOffset.top + MAX_POPUP_HEIGHT - (containerOffset.top + $container.height());
          const topOverflow = -(itemOffset.top + $item.height() - MAX_POPUP_HEIGHT - containerOffset.top);
          scope.alignBottomWithParent = bottomOverflow > 0 && bottomOverflow > topOverflow;
        }
      }
    }
    scope.visible = visible;
  };

  $item.click(e => {
    e.preventDefault();
    e.stopPropagation();
  });
  $popup.click(e => {
    e.preventDefault();
    e.stopPropagation();
  });

  // fix to prevent memory leak
  scope.$on('$destroy', () => {
    // remove listener
    $item.off('click');
    $popup.off('click');
  });
  elem.on('$destroy', () => {
    scope.$destroy();
  });
};

export default 'comment';
